<template>
  <v-container>

    <v-layout justify-center>
      <v-flex xs12 sm8 md4>
        <h1 class="grey--text"> Iniciar sesión</h1>
        <v-img src="https://medicover.mx/img/imagen-login.webp" max-height="140" cover
          class="bg-grey-lighten-2"></v-img>
        <v-divider></v-divider>
        <br />
        <h3 class="grey--text"> Ingresa tus credenciales</h3>
        <br />
        <form @submit.prevent="login">
          <v-text-field outlined clearable dense v-model="email" :rules="emailRules" label="Correo electrónico"
            required></v-text-field>
          <v-text-field outlined clearable dense label="Contraseña" :type="showPassword ? 'text' : 'password'"
            :rules="contrarquerido" v-model="password" required :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility"></v-text-field>
          <v-alert dense text type="error" v-if="this.mostrarerror">
            {{ this.errormensaje }}
          </v-alert>
          <!-- <a 
                href="/usuario-membresia"
                style="color:gray;font-weight: bold;text-decoration: none;">¿No tienes? Activa tu cuenta con tu membresía, da clic aquí.</a>
          <br/>--><a target="_blank" :href="this.WhatsApp" style="color:gray;font-weight: bold;">Ayuda</a>
          <v-spacer></v-spacer>
          <br />
          <div class="d-flex flex-column justify-space-between align-center">
            <v-btn color="azul_med" depressed elevation="2" large outlined rounded type="submit">
              Iniciar sesión</v-btn>
          </div>

        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  name: 'LoginView',
  validations: {
  },
  data: () => ({
    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Web Hola, tengo problemas al entrar ')}`,
    email: '',
    mostrarerror: false,
    errormensaje: null,
    emailRules: [
      (v) => !!v || 'Correo requerido',
      (v) => /.+@.+\..+/.test(v) || 'Correo invalido'
    ],
    password: '',
    showPassword: false,
    contrarquerido: [
      (v) => !!v || 'Contraseña requerida'
    ]
  }),
  computed: {
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      // !this.$v.checkbox.checked && errors.push('You must agree to continue!');
      return errors
    },
    selectErrors() {
      const errors = []
      if (!this.$v.select.$dirty) return errors
      // !this.$v.select.required && errors.push('Item is required');
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
      // !this.$v.name.required && errors.push('Name is required.');
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      // !this.$v.email.email && errors.push('Must be valid e-mail');
      // !this.$v.email.required && errors.push('E-mail is required');
      return errors
    }
  },
  created() {
    this.$store
      .dispatch('logout', {})
  },
  beforeMount() {
  },
  mounted() {
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      // this.$refs.form.validate();
    },
    async login() {

      try {
        const responseurl = await this.$store.dispatch('login', {
          email: this.email,
          password: this.password
        });
        console.log(responseurl)
        //this.$router.replace('/colaborador');

      } catch (error) {
        this.mostrarerror = true;
        this.errormensaje = "Ocurrió un error al procesar tu solicitud.";
      }
    },
    submit() {
      this.$v.$touch()
    },
    clear() {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    }
  }
}
</script>